import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mountain, Lock } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAdminAuth } from "../AuthContext";
import { apiError } from "../api";

export default function Login() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 px-4" data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="w-full max-w-sm rounded-2xl bg-slate-900 border border-slate-800 p-8 space-y-5">
        <div className="flex items-center gap-3">
          <span className="h-10 w-10 grid place-items-center rounded-xl bg-emerald-500 text-white">
            <Mountain className="h-5 w-5" />
          </span>
          <div>
            <div className="text-white font-semibold">RandZ Admin</div>
            <div className="text-xs text-slate-500">Sign in to manage your website</div>
          </div>
        </div>
        <div className="grid gap-2">
          <Label htmlFor="email" className="text-slate-300">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-slate-800 border-slate-700 text-white" data-testid="admin-login-email" />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="password" className="text-slate-300">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-slate-800 border-slate-700 text-white" data-testid="admin-login-password" />
        </div>
        {error && <div className="text-sm text-red-400 bg-red-500/10 rounded-lg px-3 py-2" data-testid="admin-login-error">{error}</div>}
        <Button type="submit" disabled={loading} className="w-full bg-emerald-500 hover:bg-emerald-600 text-white h-11" data-testid="admin-login-submit">
          <Lock className="h-4 w-4 mr-2" /> {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
